import { useState, useEffect } from 'react';

/**
 * Custom hook for localStorage persistence
 */
export const useLocalStorage = (key, initialValue) => {
  const [value, setValue] = useState(() => {
    try {
      const saved = localStorage.getItem(key);
      return saved !== null ? saved : initialValue;
    } catch {
      return initialValue;
    }
  });

  useEffect(() => {
    try {
      if (value !== null && value !== undefined) {
        localStorage.setItem(key, value);
      }
    } catch {
      // Ignore localStorage errors
    }
  }, [key, value]);

  return [value, setValue];
};
